import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodechefComponent } from './simple-icons-codechef.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodechefComponent ],
    exports:      [ SimpleIconsCodechefComponent ],
    bootstrap:    []
})
export class SimpleIconsCodechefModule {}
